import css from "./popUp.module.css";
import React from "react";

const ChouseBook = React.forwardRef(({ onClick }, ref) => {
  return (
    <div className={css.mainPopWrapChose} ref={ref} onClick={onClick}>
      <p className={css.mainPopP}>
        Ми ті, хто створює книгу з ідеї, з першоелемента, як Малевич: від
        чорного квадрата до великого барвистого світу, яким цікаво й корисно
        мандрувати. Ми прагнемо долучати майстрів до створення кожного видання.
        За допомогою пера й пензля вони вкладають у дитячу книгу свій цінний
        досвід, який захоплює і допомагає дітям стати на власний шлях майстра.
        Настав час майстрів!
      </p>
    </div>
  );
});
export default ChouseBook;
